<template>
  <div class="row">
    <div class="col-md-12">
      <div class="panel">
        <div class="panel-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group text-center"></div>
              <div class="profile_user">
                <h3 class="user_name_max">{{ users.name }}</h3>
                <p>{{ users.email }}</p>
              </div>
              <!-- Main Content -->
              <div class="main-content">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        <div class="card-title">
                          Meu Perfil
                          <span class="required_fields">
                            <span class="required">*</span> Campos obrigatórios
                          </span>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-10">
                            <form action>
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userName">
                                      <span class="required">*</span> Nome
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="userName"
                                      v-model="users.name"
                                      placeholder
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userRG">
                                      <span class="required">*</span> Matrícula
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="users.matriculation"
                                      placeholder
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userRG">
                                      <span class="required">*</span> RG
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="userRG"
                                      v-model="users.rg"
                                      placeholder
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userCPF">
                                      <span class="required">*</span> CPF
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="userCPF"
                                      v-model="users.cpf"
                                      placeholder
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userEmail">
                                      <span class="required">*</span> E-mail
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="userEmail"
                                      v-model="users.email"
                                      placeholder
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userCellphone">
                                      <span class="required">*</span> Celular
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="userCellphone"
                                      v-model="users.cellphone"
                                      placeholder
                                      v-mask="'(##) #####-####'"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userDateOfBirth">
                                      <span class="required">*</span> Data
                                      Nascimento
                                    </label>
                                    <input
                                      type="date"
                                      class="form-control"
                                      id="userDateOfBirth"
                                      v-model="users.date_of_birth"
                                      placeholder
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userNumberCNH">
                                      <span class="required">*</span> Número da
                                      CNH
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="userNumberCNH"
                                      v-mask="'###########'"
                                      v-model="users.number_cnh"
                                      placeholder
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userDateValidityCNH">
                                      <span class="required">*</span> Data de
                                      Validade da CNH
                                    </label>
                                    <input
                                      type="date"
                                      class="form-control"
                                      id="userDateValidityCNH"
                                      v-model="users.validity_cnh"
                                      placeholder
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userDatePriCNH">
                                      <span class="required">*</span> Data
                                      Primeira Habilitação
                                    </label>
                                    <input
                                      type="date"
                                      class="form-control"
                                      id="userDatePriCNH"
                                      v-model="users.pri_cnh"
                                      placeholder
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userCateg" disabled>
                                      <span class="required">*</span> Categoria
                                      da CNH
                                    </label>

                                    <multiselect
                                      v-model="users.cat_cnh"
                                      :multiple="true"
                                      :options="options"
                                      :close-on-select="true"
                                      placeholder="Selecione a categoria..."
                                      class="selectCategorias"
                                    ></multiselect>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userDepartment">
                                      <span class="required">*</span>
                                      Departamento
                                    </label>
                                    <select
                                      v-model="users.department_id"
                                      class="form-control"
                                      disabled
                                    >
                                      <option
                                        v-for="department in departments"
                                        :value="department.id"
                                        :key="department.id"
                                      >
                                        {{ department.description }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label for="userPic">Foto do Usuário</label>
                                    <input
                                      type="file"
                                      class="form-control"
                                      id="userPic"
                                      accept="image/*"
                                      name="userPic"
                                      @change="uploadImage"
                                      placeholder
                                    />

                                    <input
                                      type="hidden"
                                      name="user[id]"
                                      :value="users.id"
                                      :v-model="users.ignore"
                                    />
                                  </div>
                                </div>
                                <br />
                                <br />
                                <br />
                                <div class="col-md-12">
                                  Você só precisa preencher os campos de senha,
                                  caso deseje alterá-la.
                                </div>
                                <br />
                                <br />
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userPassword">
                                      <span class="required"></span> Senha
                                    </label>
                                    <input
                                      type="password"
                                      class="form-control"
                                      id="userPassword"
                                      v-model="users.password"
                                      placeholder
                                      autocomplete="false"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label for="userPasswordConfirmation">
                                      <span class="required"></span> Confirme a
                                      Senha
                                    </label>
                                    <input
                                      type="password"
                                      class="form-control"
                                      id="userPasswordConfirmation"
                                      v-model="users.password_confirmation"
                                      placeholder
                                      autocomplete="false"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div class="block text-right">
                                <a class="btn btn-add" @click="save">
                                  Salvar
                                  <i class="fa fa-save"></i>
                                </a>
                                <router-link to="/" class="btn btn-back">
                                  <i class="fa fa-arrow-left"></i> Voltar
                                </router-link>
                              </div>
                            </form>
                          </div>
                          <div class="col-md-2">
                            <div class="circular--landscape">
                              <img
                                v-if="previewImage"
                                :src="previewImage"
                                width="100%"
                                height="198"
                                class="tratament"
                              />
                              <img
                                v-else
                                :src="users.photo"
                                alt
                                width="100%"
                                height="198"
                                class="tratament"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalReservado"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalReservadoTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalReservadoTitle">
              Informações da pré-reserva
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      users: {
        name: "",
        matriculation: "",
        rg: "",
        cpf: "",
        email: "",
        cellphone: "",
        date_of_birth: "",
        cat_cnh: "",
        validity_cnh: "",
        pri_cnh: "",
        number_cnh: "",
        admission_date: "",
        password: "",
        password_confirmation: "",
        branch_id: "",
        access_nivel: "",
        photo: "",
      },
      departments: [],

      selected: null,
      options: ["A", "B", "C", "D", "E"],

      errors: undefined,

      previewImage: null,
    };
  },
  mounted: function () {
    const self = this;

    // Tradução do Multiselect
    $("span").attr("data-select", "Pressione enter para selecionar");
    $("span").attr("data-selected", "Selecionado");
    $("span").attr("data-deselect", "Pressione enter para remover");

    var data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = data.getFullYear();
    data = anoF + "-" + mesF + "-" + diaF;

    self.now = data.toString();

    this.users = this.$store.state.user;

    if (this.users.cpf == null) {
      self.$message(
        "Atenção",
        `Atualize seus dados para continuar utilizando o sistema`,
        "error"
      );
    }

    this.authenticated = this.$store.getters.authenticated;

    this.getDepartments();
    this.getAcceptTerms();
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("user_id", self.users.id);
      fd.append("name", self.users.name);
      fd.append("matriculation", self.users.matriculation);
      fd.append("rg", self.users.rg);
      // fd.append("date_of_birth", self.users.date_of_birth);
      fd.append("cpf", self.users.cpf);
      fd.append("email", self.users.email);
      fd.append("cellphone", self.users.cellphone);
      fd.append("cat_cnh", self.users.cat_cnh);
      fd.append("department_id", self.users.department_id);
      // fd.append("validity_cnh", self.users.validity_cnh);
      // fd.append("pri_cnh", self.users.pri_cnh);
      fd.append("number_cnh", self.users.number_cnh);
      // fd.append("admission_date", self.users.admission_date);
      fd.append("photo", photo.files[0] ? photo.files[0] : "");
      fd.append("access_nivel", self.users.access_nivel);
      fd.append("password", self.users.password);
      fd.append("password_confirmation", self.users.password_confirmation);

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PATCH");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      let fd = self.makeFormData();

      if (self.users.id) {
        api += "/" + self.users.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Usuário atualizado com sucesso`, "success");
          this.$router.push("/profile");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },

    getAcceptTerms: function () {
      this.url = this.$route.params.accept_terms;

      console.log(this.url);
    },

    getDepartments: function (id) {
      const self = this;
      const api = self.$store.state.api + "departments/";

      self.$http
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeid() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
  },
  components: {
    BaseCrud,
    Multiselect,
  },
};
</script>

<style scoped>
.img-bor {
  width: 150px;
}

.profile_user {
  text-align: center;
}

.tratament {
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/Profile.vue